<template>
  <div>
    <div
      class="currencyPrice flex flex-wrap"
      data-qa="bid-price">
      <v-tooltip
        content-class="price-tooltip tooltip white black--text pa-0"
        top>
        <template #activator="{ on }">
          <div
            :class="{'secondary__green_not_active--text': item.bidStatus == 'DRAFT', ' best-price-chip secondary__green_approved px-2 rounded-lg': show_best_price && item.bestPrice}"
            data-qa="bid-price-tooltip-btn"
            v-on="show_best_price && item.bestPrice ? on : ''">
            {{ $formatBidPrice(item.currencyPrice) }}
            {{ item.currencyTitle }}
          </div>
        </template>
        <div
          class="tooltip-item text-start pa-2"
          data-qa="bid-price-tooltip-content">
          <span class="black--text h8-text text-start">{{ $t('Tenders.BidPriceTooltipText') }}</span>
        </div>
      </v-tooltip>
      <sButton
        v-if="has_price_request"
        class="btn-history"
        data-qa="bid-price-btn-history"
        :icon="loadingHistory ? 'loading' : 'arrow'"
        :icon-class="loadingHistory ? 's-svg-icon-spin' : (open_history ? '' : 's-svg-icon-rotate--90')"
        :icon-size="'10px'"
        small
        type="text"
        @click.prevent.stop="openHistory"/>
    </div>
    <v-list
      v-if="open_history"
      class="price-history pa-0"
      :class="{'secondary__green_not_active--text': item.bidStatus == 'DRAFT'}"
      dense>
      <v-tooltip
        v-for="(history_item, index) in history_items"
        :key="index"
        content-class="price-tooltip tooltip white black--text pa-0"
        top>
        <template #activator="{ on }">
          <div
            :class="[ getColor(history_item) + '--text', 'flex align-center font-size-13 mt-1']"
            data-qa="bid-price-tooltip-history-row"
            v-on="on">
            <div class="mr-1">
              <sIcon
                class="my-auto"
                :color="`var(--v-${getColor(history_item)}-base)`"
                :data-qa="`bid-price-tooltip-history-${history_item.status}`"
                :rotate="history_item.status == 'ACTIVE' ? '270' : ''"
                size="10"
                :type="getIcon(history_item)"/>
            </div>
            <div
              data-qa="bid-price-tooltip-history-currency">
              {{ tendersSettings.priceRoundingDigit ? $formatPrice(history_item.price, tendersSettings.priceRoundingDigit) : formSum(history_item.price) }}
              {{ item.currencyTitle }}
            </div>
          </div>
        </template>
        <div
          v-if="history_item.dateSend"
          class="tooltip-item text-start pa-2"
          data-qa="bid-price-tooltip-history-content">
          <div>
            <span
              class="black--text h7-text-medium text-start"
              data-qa="bid-price-tooltip-history-content-item">{{ getTooltipText(history_item ) }}:</span>
            <span
              class="black--text h7-text text-start"
              data-qa="bid-price-tooltip-history-content-data"> {{ formatDate( history_item.dateSend) }} </span>
          </div>
          <div v-if="history_item.comment">
            <span
              class="black--text h7-text-medium text-start"
              data-qa="bid-price-tooltip-history-content-comment-1"> {{ bigFirstLetter($t('Suppliers.Comment')) }}:</span>
            <span
              class="black--text h7-text text-start"
              data-qa="bid-price-tooltip-history-content-comment-2"> {{ history_item.comment }}</span>
          </div>
        </div>
      </v-tooltip>
    </v-list>
    <CurrencyConversionTooltip
      v-if="item && item.price"
      :currency="item.currencyTitle"
      :current-id="currencyId"
      :price="item ? item.currencyPrice : null"/>
  </div>
</template>
// ACTIVE ACTIVE
// ACCEPTED ACCEPTED
// REJECTED REJECTED
<script>
import CurrencyConversionTooltip from 'components/common/elements/CurrencyConversionTooltip.vue'

import { mapGetters } from 'vuex'
import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

import moment from 'moment'
import { modalMixin } from 'mixins'

export default {
  name: 'bidPrice',
  mixins: [modalMixin],
  data() {
    return {
      open_history: false,
      loadingHistory: false,
      history_items: []
    }
  },
  props: {
    item: Object,
    tenderId: [Number, String],
    show_best_price: {
      type: Boolean
    },
    prevDate: {
      type: String
    },
    /**
     * Место где используется таблица.
     * На текущий момент, нужно только для правильной обработки результата запроса по изменению цены
     */
    mode: {
      type: String
    }
  },
  computed: {
    ...mapGetters({
      tendersSettings: 'getTendersSettings',
    }),
    currencyId() {
      return this.item?.currencyId ?? ''
    },
    /*nbuCurrencyRate() {
      return this.$store.getters.getNbuCurrencyRateByCurrencyId(this.currencyId) || {}
    },
    uahPrice() {
      return (this.nbuCurrencyRate?.currencyRate || 1) *  this.item?.currencyPrice
    },*/
    has_price_request() {
      return !!this.item.priceConfirmation?.price || this.item.generatedByPriceConfirmation
    }
  },
  methods: {
    async openHistory() {
      if ( !this.open_history  ) {
        this.loadingHistory = true
        await api.bidPriceRequestsByBidder({
          tenderId: +this.tenderId,
          lotId: this.item.lotId,
          bidderId: this.item.bidderInfo.organizationId
        }).then((result) => {
          let items = this.$_.sortBy(result, 'dateSend')
          if (this.mode === 'history') {
            items = items
              .filter(i =>
                new Date(i.dateSend).getTime() <= new Date(this.item.timeSupplyBids).getTime() &&
            (
              !this.prevDate ||
              new Date(i.dateSend).getTime() > new Date(this.prevDate).getTime()
            ))
          }
          this.history_items = items?.length ? items : this.has_price_request ? [this.item.priceConfirmation]  : []
        })
          .finally(() => this.loadingHistory = false)
      }
      this.open_history = !this.open_history
    },
    getColor(item) {
      switch (item.status) {
      case 'ACTIVE' : {
        return 'secondary__green_not_active'
      }
      case 'ACCEPTED' : {
        return 'secondary__green_active'
      }
      case 'REJECTED' : {
        return 'secondary__red'
      }
      default : {
        return 'var(--black-color)'
      }
      }
    },
    getIcon(item) {
      switch (item.status) {
      case 'ACTIVE' : {
        return 'long-arrow'
      }
      case 'ACCEPTED' : {
        return 'okay-arrow'
      }
      case 'REJECTED' : {
        return 'cross'
      }
      default : {
        return 'var(--black-color)'
      }
      }
    },
    getTooltipText(item) {
      switch (item.status) {
      case 'ACTIVE' : {
        return this.$t('Tenders.AskedPrice')
      }
      case 'ACCEPTED' : {
        return this.$t('Tenders.ThePriceIsAgreed')
      }
      case 'REJECTED' : {
        return this.$t('Tenders.PriceRejected')
      }
      default : {
        return ''
      }
      }
    },
    formatDate(date) {
      return moment( date).format('DD.MM.YYYY HH:mm')
    }
  },
  components: {
    CurrencyConversionTooltip
  },
  /*mounted() {
    this.$store.dispatch('setNbuCurrencyRate', this.currencyId)
  }*/
}
</script>

<style lang="scss" scoped>
.btn-history {
  min-height: 20px !important;
  min-width: 20px !important;
  height: 20px !important;
  width: 20px !important;
  margin-left: 4px !important;
}
.price-history {
  background: transparent !important;
    .v-list-item {
      min-height: unset;
      .v-list-item__icon {
        min-width: unset;
        min-height: unset;
      }
    }
}
</style>
